import { useRef, useState, useEffect } from "react";

export function useHorizontalScroll() {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;
    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

    setCanScrollLeft(!atStart);
    setCanScrollRight(!atEnd);
  };

  const handleScroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = 250;
    const el = scrollRef.current;

    if (direction === "left") {
      el.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      el.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }

    setTimeout(() => checkScroll(), 300);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    // Initial check in case content doesn't overflow
    checkScroll();

    let isDown = false;
    let startX;
    let scrollLeftStart;

    const startDragging = (e) => {
      isDown = true;
      el.classList.add("dragging");
      startX = e.pageX - el.offsetLeft;
      scrollLeftStart = el.scrollLeft;
    };

    const stopDragging = () => {
      isDown = false;
      el.classList.remove("dragging");
    };

    const onDrag = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeftStart - walk;
      checkScroll();
    };

    const onNativeScroll = () => checkScroll();

    el.addEventListener("mousedown", startDragging);
    el.addEventListener("mouseleave", stopDragging);
    el.addEventListener("mouseup", stopDragging);
    el.addEventListener("mousemove", onDrag);
    el.addEventListener("scroll", onNativeScroll);

    return () => {
      el.removeEventListener("mousedown", startDragging);
      el.removeEventListener("mouseleave", stopDragging);
      el.removeEventListener("mouseup", stopDragging);
      el.removeEventListener("mousemove", onDrag);
      el.removeEventListener("scroll", onNativeScroll);
    };
  }, []);

  return { scrollRef, canScrollLeft, canScrollRight, handleScroll };
}